import React from 'react';
import styled, { injectGlobal } from 'styled-components';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import '../assets/scss/main.scss';

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

const SiteShell = styled.div`
  height: 100vh;
`;

injectGlobal`
  body {
    background-color: #1b1f22;
      
    h1 {
      font-size: 3rem;
    }
    
    h2 {
      font-size: 2rem;
    }
    
    h3 {
      font-size: 1.5rem;
      font-weight: normal;
      letter-spacing: 8px;
    }
    
    p {
      font-size: 1.4rem;
    }
    
    li {
      font-family: Roboto, sans-serif;
      z-index: 2;
    }
    
    hr {
      margin-top: 0.5rem;
    }
  }
`;

const Layout = ({ children, location }) => {
  let content;

  if (location && location.pathname === '/') {
    content = <ContentContainer>{children}</ContentContainer>;
  } else {
    content = (
      <div id="wrapper" className="page">
        <ContentContainer>{children}</ContentContainer>
      </div>
    );
  }

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <SiteShell>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: 'description', content: 'Sample' },
              { name: 'keywords', content: 'sample, something' },
            ]}
          >
            <link
              rel="stylesheet"
              type="text/css"
              charset="UTF-8"
              href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css"
            />
            <link
              rel="stylesheet"
              type="text/css"
              href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick-theme.min.css"
            />
            <script src="https://cdn.rawgit.com/progers/pathseg/master/pathseg.js" />
            <html lang="en" />
          </Helmet>
          {content}
        </SiteShell>
      )}
    />
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
